module.exports = __webpack_public_path__ + "img/22800.ddc57abd.jpg";